const getCtaSessionInfo = (): { sessionId: string; isUnique: boolean } => {
  const SESSION_KEY = 'linkie_cta_session_id';
  const TIMESTAMP_KEY = 'linkie_cta_session_timestamp';
  const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;

  const timestamp = Number(localStorage.getItem(TIMESTAMP_KEY));
  const now = Date.now();
  let sessionId = localStorage.getItem(SESSION_KEY);

  const isExpired = !timestamp || now - timestamp > TWENTY_FOUR_HOURS;
  const isUnique = isExpired;

  if (!sessionId || isExpired) {
    sessionId = crypto.randomUUID();
    localStorage.setItem(SESSION_KEY, sessionId);
    localStorage.setItem(TIMESTAMP_KEY, now.toString());
  }

  return { sessionId, isUnique };
};

export default getCtaSessionInfo;
